export const ITEMS_GLOBAL_KEY = 'global'
export const ITEMS_UNITED_STATES_KEY = 'unitedStates'

const FOOTER_COLUMNS = [
  {
    title: { text: 'Not Sure Where to Go?', href: '/locations/' },
    items: {
      [ITEMS_GLOBAL_KEY]: [
        {
          href: '/destinations/',
          text: 'Destinations Videos'
        },
        {
          href: '/europe/',
          text: 'Rehabs in Europe'
        },
        {
          href: '/thailand/',
          text: 'Rehabs in Thailand'
        },
        {
          href: '/united-kingdom/',
          text: 'Rehabs in the UK'
        },
        {
          href: '/canada/',
          text: 'Rehabs in Canada'
        },
        {
          href: '/australia/',
          text: 'Rehabs in Australia'
        }
      ],
      [ITEMS_UNITED_STATES_KEY]: [
        {
          href: '/florida/',
          text: 'Rehabs in Florida'
        },
        {
          href: '/california/',
          text: 'Rehabs in California'
        },
        {
          href: '/new-york/',
          text: 'Rehabs in New York'
        },
        {
          href: '/texas/',
          text: 'Rehabs in Texas'
        },
        {
          href: '/arizona/',
          text: 'Rehabs in Arizona'
        }
      ]
    }
  },
  {
    title: { text: 'Popular Centers', href: '/united-states/' },
    items: {
      [ITEMS_GLOBAL_KEY]: [
        {
          href: '/luxury/',
          text: 'Luxury Rehab Centers'
        },
        {
          href: '/care/detox/',
          text: 'Detox Centers'
        },
        {
          href: '/therapies/cognitive-behavioral-therapy/',
          text: 'Cognitive Behavior Therapy'
        },
        {
          href: '/care/sober-living/',
          text: 'Sober Living Homes'
        },
        {
          href: '/clientele/lgbtq/',
          text: 'LGBTQ+ Friendly Rehab'
        },
        {
          href: '/approach/wellness/',
          text: 'Wellness Centers'
        },
        {
          href: '/amenities/pet-friendly/',
          text: 'Pet Friendly Rehabs'
        },
        {
          href: '/amenities/allow-cell-phones/',
          text: 'Rehabs that Allow Cell Phones'
        }
      ]
    }
  },
  {
    title: { text: 'Top Specializations', href: '/condition/' },
    items: {
      [ITEMS_GLOBAL_KEY]: [
        {
          href: '/condition/eating-disorders/',
          text: 'Eating Disorder Treatment'
        },
        {
          href: '/condition/depression/',
          text: 'Depression Treatment'
        },
        {
          href: '/clientele/executives/',
          text: 'Executive Rehab'
        },
        {
          href: '/clientele/adolescents/',
          text: 'Teen Rehab Centers'
        },
        {
          href: '/condition/co-occurring-disorders/',
          text: 'Dual Diagnosis Rehabs'
        },
        {
          href: '/condition/trauma/',
          text: 'Residential Trauma Treatment'
        },
        {
          href: '/condition/sex-addiction/',
          text: 'Sex Addiction Treatment'
        },
        {
          href: '/approach/christian/',
          text: 'Christian Treatment Centers'
        }
      ]
    }
  },
  {
    title: { text: 'Top Resources', href: '/resources/' },
    items: {
      [ITEMS_GLOBAL_KEY]: [
        {
          href: '/resources/request-time-off-work-for-rehab/',
          text: 'Can I Get Fired for Going to Rehab?'
        },
        {
          href: '/resources/cost-of-rehab-and-insurance-coverage-faqs/',
          text: 'Is Rehab Covered by Insurance?'
        },
        {
          href: '/resources/staging-an-intervention-everything-you-need-to-know-to-prepare/',
          text: 'Tips for Staging an Intervention'
        },
        {
          href: '/resources/how-much-does-rehab-cost/',
          text: 'How Much Does Rehab Cost?'
        }
      ]
    }
  },
  {
    title: {
      text: 'For Treatment Providers',
      href: 'https://providers.recovery.com/'
    },
    items: {
      [ITEMS_GLOBAL_KEY]: [
        {
          href: '/claim-verify-process/',
          text: 'Claim Your Rehab Center'
        },
        {
          href: 'https://providers.recovery.com/',
          text: 'Explore Marketing Solutions'
        },
        {
          href: '/about/',
          text: 'About Us'
        },
        {
          href: '/contact/',
          text: 'Contact Us'
        }
      ]
    },
    subHeading: {
      title: {
        text: 'Connect with Us',
        href: '/contact/'
      },
      items: [
        {
          text: 'social-media-links'
        }
      ]
    }
  }
]

export default FOOTER_COLUMNS
